const LAST_CUSTOMER_STORAGE_KEY = 'scout-last-customer'

/**
 * Reads the last-viewed customer from localStorage.
 */
export const getLastCustomer = (): string | null => {
  try {
    return window.localStorage.getItem(LAST_CUSTOMER_STORAGE_KEY)
  } catch {
    // Storage can throw (private mode, disabled cookies); treat as no value.
    return null
  }
}

/**
 * Persists the last-viewed customer to localStorage.
 */
export const setLastCustomer = (customerRegardId: string): void => {
  try {
    window.localStorage.setItem(LAST_CUSTOMER_STORAGE_KEY, customerRegardId)
  } catch {
    // Storage unavailable; the next visit simply falls back to another default.
  }
}
